// Base local del POS offline (IndexedDB vía Dexie). Es el ÚNICO archivo que importa Dexie:
// el resto de la app usa sus funciones.
import Dexie from 'dexie';

export const db = new Dexie('zapi_pos');

db.version(1).stores({
  // Una fila por sucursal: { sucursal_id, user_id, productos, paquetes, smart_combos, bordes, extras,
  //   grupos, canales, caja, empresa_logo, encabezado_ticket, descargado_en, version_app }
  catalogo: 'sucursal_id',

  // Una fila por venta. Clave = uuid_venta.
  // { uuid_venta, caja_id, sucursal_id, correlativo_local, fecha_venta_cliente, creada_en,
  //   payload (inmutable), ticket (inmutable),
  //   estado, intentos, venta_id,                                   // campos de control (punto 6)
  //   proximo_intento_en, ultimo_error, sincronizada_en }          // metadatos de control
  cola_ventas: 'uuid_venta, estado, caja_id, [caja_id+estado], fecha_venta_cliente, sincronizada_en',

  // Una fila por caja: { caja_id, ultimo_correlativo, ventas_sesion }
  contadores: 'caja_id',

  // Cierres por /caja/sync que no pudieron enviarse (punto 13): { uuid_cierre, caja_id, payload, estado, intentos, ... }
  cierres_cola: 'uuid_cierre, caja_id, estado',
});

// v2 (Etapa 3A): imágenes del catálogo como blobs. Las tablas de v1 no cambian.
db.version(2).stores({
  // { url, blob, tipo, guardado_en }: una fila por URL de imagen (si la URL cambia, es otra imagen)
  imagenes: 'url, guardado_en',
});

// Abre la base al entrar con sesión, para detectar a tiempo un navegador que no permite IndexedDB
// (p. ej. algunas ventanas privadas). No lanza: devuelve true o false.
export async function abrirPosDb() {
  try {
    await db.open();
    return true;
  } catch (error) {
    console.error('No se pudo abrir la base local del POS (IndexedDB):', error);
    return false;
  }
}
